import { render } from "./CommonImport.vue?vue&type=template&id=73d9b5e5&scoped=true&ts=true"
import script from "./CommonImport.vue?vue&type=script&lang=ts"
export * from "./CommonImport.vue?vue&type=script&lang=ts"

import "./CommonImport.vue?vue&type=style&index=0&id=73d9b5e5&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d9b5e5"]])

export default __exports__